import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPoint } from '@constants/api.constant';
import { IResponse } from '@models/common.model';
import { Observable, map } from 'rxjs';

@Injectable()
export class ResponseMapperInterceptor implements HttpInterceptor {
  private readonly endpointConfig = Object.values(EndPoint);
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      map(event => {
        if (event instanceof HttpResponse && event.status === 200) {
          return this.mapResponse(request, event);
        }
        return event;
      })
    );
  }

  private mapResponse(
    request: HttpRequest<unknown>,
    event: HttpResponse<IResponse<unknown>>
  ) {
    const url = request.url;
    const endpoint = this.endpointConfig.find(endpoint =>
      url.includes(endpoint.path)
    );
    if (endpoint?.mapper && event.body) {
      return event.clone({
        body: endpoint.mapper(event.body),
      });
    }
    return event;
  }
}

export const responseMapperInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: ResponseMapperInterceptor,
  multi: true,
};
